import { useState, useEffect } from 'react';
import styles from '../styles/Navbar.module.css';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [animateNav, setAnimateNav] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);

        // Re-trigger animation
        if (!isOpen) {
            setAnimateNav(false); // Remove the animation class
            requestAnimationFrame(() => {
                setAnimateNav(true); // Re-add it on next frame
            });
        }
    };

    // Body scroll verhindern, wenn Menü offen
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    }, [isOpen]);

    return (
        <header className={styles.navbar}>

            <div className={styles.brandText}>
                Aus einem Traum wird Fahrspaß
            </div>

            <button className={styles.burger} onClick={toggleMenu}>
                <span className={`${styles.bar} ${isOpen ? styles.bar1 : ''}`} />
                <span className={`${styles.bar} ${isOpen ? styles.bar2 : ''}`} />
                <span className={`${styles.bar} ${isOpen ? styles.bar3 : ''}`} />
            </button>

            <nav className={`${styles.navLinks} ${isOpen ? styles.open : ''} ${animateNav ? styles.animated : ''}`}>
                <a href="#services" onClick={toggleMenu} style={{ scrollBehavior: 'smooth', animationDelay: '0.1s' }}>Dienstleistungen</a>
                <a href="#anfahrt" onClick={toggleMenu} style={{ scrollBehavior: 'smooth', animationDelay: '0.2s' }}>Anfahrt</a>
                <a href="#contact" onClick={toggleMenu} style={{ scrollBehavior: 'smooth', animationDelay: '0.3s' }}>Kontakt</a>
            </nav>
        </header>
    );
};

export default Navbar;
